module.exports = __webpack_public_path__ + "media/images/vehicles/star-29db7a0bb775043af3b629a19dbeae22.png";